export default __webpack_public_path__ + "static/media/practice-test-3.e7f75597.csv";